import Link from 'next/link'
import cx from 'classnames'
import {
  getMainCategoryObject,
  getSubcategoryObject,
} from '../main-nav/main-nav'
import { UiPlacement } from '@/types/api/ui-placement'
import { navItemOnClickGTMEvent } from '@/utils/gtmEvents/navItemOnClickGTMEvent'
import sDesktop from '../main-nav/main-nav.module.css'
import sMobile from '../main-nav-mobile/main-nav-mobile.module.css'

type Props = {
  row: UiPlacement[]
  mainCatObj: ReturnType<typeof getMainCategoryObject>
  handleCloseMenu: () => void
  variant: 'desktop' | 'mobile'
}

export function NavSubcategoryList({
  row,
  mainCatObj,
  handleCloseMenu,
  variant = 'desktop',
}: Props) {
  const groupedByRowTitle = row.reduce(
    (acc, r) => {
      const key = r.metadata?.rowTitle as string
      if (!acc[key]) acc[key] = []
      acc[key].push(r)
      return acc
    },
    {} as { [key: string]: UiPlacement[] }
  )

  const isMultiTitle = Object.keys(groupedByRowTitle).length > 1
  const styles = variant === 'desktop' ? sDesktop : sMobile

  if (isMultiTitle) {
    return (
      <div className={styles.twoTitlesColumnWrapper}>
        {Object.values(groupedByRowTitle).map((columnWithRows, colIdx) => (
          <ul
            key={colIdx}
            className={
              variant === 'desktop' ? styles.navListSubcategory : styles.navList
            }
            style={{ padding: variant === 'mobile' ? 0 : 'initial ' }}
          >
            {!!columnWithRows[0]?.metadata?.rowTitle && (
              <li
                className={cx(
                  styles.navSubItem || styles.navItem,
                  styles.navSubRowTitle
                )}
              >
                {columnWithRows[0]?.metadata?.rowTitle}
              </li>
            )}
            {columnWithRows.map((subcategory, idx) => {
              const subcategoryObj = getSubcategoryObject(
                mainCatObj,
                subcategory
              )
              return (
                <li
                  key={`${subcategoryObj?.slug}/${idx}`}
                  className={cx(styles.navSubItem || styles.navItem, {
                    [styles.navItemWithRowTitle]:
                      !!columnWithRows[0]?.metadata?.rowTitle,
                  })}
                  onClick={handleCloseMenu}
                >
                  <Link
                    href={subcategoryObj?.slug || ''}
                    className={styles.navLinkSubcategory || styles.navLink}
                    onClick={() => navItemOnClickGTMEvent(subcategoryObj?.name)}
                  >
                    {subcategoryObj?.name}
                  </Link>
                </li>
              )
            })}
          </ul>
        ))}
      </div>
    )
  }

  return (
    <ul
      className={
        variant === 'desktop' ? styles.navListSubcategory : styles.navList
      }
      style={{ padding: variant === 'mobile' ? 0 : 'initial ' }}
    >
      {!!row[0]?.metadata?.rowTitle && (
        <li
          className={cx(
            styles.navSubItem || styles.navItem,
            styles.navSubRowTitle
          )}
        >
          {row[0]?.metadata?.rowTitle}
        </li>
      )}
      {row.map((subcategory, idx) => {
        const subcategoryObj = getSubcategoryObject(mainCatObj, subcategory)
        return (
          <li
            key={`${subcategoryObj?.slug}/${idx}`}
            className={cx(styles.navSubItem || styles.navItem, {
              [styles.navItemWithRowTitle]: !!row[0]?.metadata?.rowTitle,
            })}
            onClick={handleCloseMenu}
          >
            <Link
              href={subcategoryObj?.slug || ''}
              className={styles.navLinkSubcategory || styles.navLink}
              onClick={() => navItemOnClickGTMEvent(subcategoryObj?.name)}
            >
              {subcategoryObj?.name}
            </Link>
          </li>
        )
      })}
    </ul>
  )
}
